import React, { useState } from 'react';
import CardProfile from '../../../components/Profile/Card/';
import ContactFirm from '../../../components/Forms/Perfil/ContactFirm';
import ContactLawyer from '../../../components/Forms/Perfil/ContactLawyer';
import Snackbar from '../../../components/Snackbar';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { addinfoProfile } from '../../../store/actions/UserAction'
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { validationContactLawyer, validationContactFirm } from '../../../utils/validations';
import TrophieModal from '../../../components/Modal/TrophieModal';
import './Contact.scss';

const Contact = ({role ,uid, addinfoProfile, contacto, authClient, trophie, showLoading, hideLoading }) => {
  const [openTrophieModal, setOpenTrophieModal] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success'
  });

  const handleOpenTrophieModal = () => {
    setOpenTrophieModal(true);
  };

  const handleCloseTrophieModal = () => {
    setOpenTrophieModal(false);
  };

  const handleSnack = () => {
    setFeedbackMessage({
      open: true,
      message: 'Tus cambios se han guardado con éxito',
      variant: 'success'
    });
  }

  const threeMinimumValues = (values) => {
    const valuesInArray = Object.values(values)
    const filteredArray = valuesInArray.filter(elem => {
      if (!elem) {}
      return elem
    })
    if (filteredArray.length >= 3) {
      return true
    }
    return false
  }

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    // const arrayValues = Object.values(values)
    // const boolValues = arrayValues.every(elem => elem)
    const boolValues = threeMinimumValues(values)
    showLoading();
    setSubmitting(false);
    addinfoProfile(uid, values, boolValues)
      .then(res => {
        hideLoading()
        if (boolValues === false || trophie) {
          handleSnack();
        }
        if (boolValues === true && !trophie) {
          handleOpenTrophieModal()
        }
    })
      .catch(error => {})
    };

    const handleCloseFeedbackMessage = () => {
      setFeedbackMessage({
        open: false,
        message: '',
        variant: 'success'
      });
    };
  
    let formValuesFirm ={}
    if (contacto) {
      formValuesFirm = {
        phone: contacto.phone,
        movil: contacto.movil,
        whats: contacto.whats,
        email: contacto.email,
        blog: contacto.blog
      };
    } else {
      formValuesFirm = {
        phone: '',
        movil: '',
        whats: '',
        email: authClient.user.email ? authClient.user.email : '',
        blog: ''
      };
    }
  
    let formValuesLawyer ={};

    if (contacto) {
      formValuesLawyer = {
        phone:contacto.phone ,
        movil:contacto.movil,
        whats:contacto.whats,
        email:contacto.email,
        blog:contacto.blog
      };
    } else {
      formValuesLawyer = {
        phone: authClient.phone,
        movil: '',
        whats: '',
        email: '',
        blog: ''
      };
    }
    
  return (
    <div className={'contact'}>
      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophie}
        topic="award-profile"
        handleClose={handleCloseTrophieModal}
        title={authClient.role === 'lawFirm' ?
          'Información del despacho' :
          'Información de contacto'
        }
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer={authClient.role === 'lawFirm' ?
          'El nombre del despacho y los datos de contacto son muy importantes para tu clientes' :
          'Tu nombre y los datos de contacto son muy importantes para tu clientes'
        }
      />


      <CardProfile
        title={role === 'lawFirm' ? 'Información del despacho' : 'Información de contacto'}
        subTitle={['Datos de contacto visibles para los clientes, ', <b>debes incluir al menos tres opciones de contacto.</b>]}
        status={authClient && authClient.awardPerfil.contact ? authClient.awardPerfil.contact : false}
        awardIcon
      >
        <Formik
          initialValues={role === 'lawFirm' ? formValuesFirm : formValuesLawyer}
          validationSchema={role === 'lawFirm' ? validationContactFirm : validationContactLawyer }
          onSubmit={handleSubmit}
          render={props => role === 'lawFirm' ?
            (
              <ContactFirm
                {...props}
                threeMinimumValues={threeMinimumValues}
              />
            ) :
            (
              <ContactLawyer
                {...props}
              />
            )
          }
        />
      </CardProfile>
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  authClient: state.authClient,
  contacto: state.authClient.contacto,
  trophie: state.authClient.awardPerfil.contact
});

const mapDispatchToProps = dispatch => ({
  addinfoProfile : (uid, values, boolValues) => dispatch(addinfoProfile(uid, values, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
}); 
 
export default connect(mapStateToProps, mapDispatchToProps)(Contact);
